import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// global styles
import './assets/main.css'
import { handleErrors } from './views/views_functions/errorHandler'
import './registerServiceWorker'
import { states } from './main_store'

// Capture beforeinstallprompt event globally (fires early, before components mount)
window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    states.value.deferredInstallPrompt = e;
    console.log('PWA install prompt captured globally');
});

const app = createApp(App)

app.config.errorHandler = (err) => {
    handleErrors(err)
    console.log(err)
}
app.use(router).mount('#app')
